<template>
  <svg
  version="1.1"
  id="Layer_1"
  xmlns="http://www.w3.org/2000/svg"
  xmlns:xlink="http://www.w3.org/1999/xlink"
  x="0px"
  y="0px"
  fill="currentColor"
  viewBox="0 0 23.6 36.5"
  style="enable-background:new 0 0 23.6 36.5;width: 22.5px;margin-left: 10px;"
  xml:space="preserve">
  <polygon points="16.9,0 16.9,15.5 0,0 0,36.5 16.9,21 16.9,36.5 23.6,36.5 23.6,0 "/>
  </svg>
</template>

<script>
export default {
  name: 'IconPlay'
}
</script>
